import { Theme } from '../../../design_system';
import { themeKey } from '../types';

export default function saveTheme(theme: Theme) {
  try {
    localStorage.setItem(themeKey, theme);
  } catch (err) {
    // Just silently fail
  }
}
